// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ghost{border-top:2px solid #2196f3}.playlist-headline{font-size:1.5rem;letter-spacing:normal}", ""]);
// Exports
module.exports = exports;
